import './styles/main.scss'
import './styles/pages/_contact.scss'
import './scripts/common'
import './scripts/nav'
import './scripts/footer'
import { $, axios, get } from './utils'
import Form from './models/Form'

const form = new Form('#form', {
  submit(fields) {
    axios.head('/csrf')
      .then(res => {
        const csrfToken = res.headers['x-csrf-token']
        const data = {
          authenticity_token: csrfToken,
          apply: fields
        }
        axios.post('/applies.json', data)
          .then(() => {
            window.fbq('track', 'CompleteRegistration')
            $('.contact-form__form').innerHTML = `
              <p class="contact-form__success-msg text-primary text-center">
                您好，感謝您的申請！<br>
                您的資訊將由一頁商店審核小組進行確認，<br>
                審核流程約需 3-5 個工作天 ( 不含例假日 )。<br>
                如通過申請，我們會寄送 Email 通知您 ;<br>
                如未通過申請，恕不另行通知。<br>
                有任何問題，歡迎您於上班時間洽詢線上客服，謝謝！
              </p>
            `
          })
          .catch(err => {
            const fieldErrs = get(err, 'response.data.errors')
            if (fieldErrs) {
              form.setFieldErrs(fieldErrs)
            }
          })
      })
  }
})
